import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

/**
 * Helpers for the customer single-device session id.
 *
 * Uses Capacitor Preferences on native (survives APK updates) and
 * localStorage on web. Mirrors the driver app's single-device session
 * enforcement so a fresh login on Device B kicks Device A out automatically.
 */
export const CUSTOMER_SESSION_KEY = 'customer_session_id';
export const SESSION_INVALIDATED_EVENT = 'customer-session-invalidated';
export const FORCE_SIGNED_OUT_KEY = 'customer_force_signed_out';

export async function getCustomerSessionId(): Promise<string | null> {
  try {
    if (Capacitor.isNativePlatform()) {
      const { value } = await Preferences.get({ key: CUSTOMER_SESSION_KEY });
      return value;
    }
    return localStorage.getItem(CUSTOMER_SESSION_KEY);
  } catch {
    return null;
  }
}

export async function setCustomerSessionId(id: string | null): Promise<void> {
  try {
    if (Capacitor.isNativePlatform()) {
      if (id) await Preferences.set({ key: CUSTOMER_SESSION_KEY, value: id });
      else await Preferences.remove({ key: CUSTOMER_SESSION_KEY });
    } else {
      if (id) localStorage.setItem(CUSTOMER_SESSION_KEY, id);
      else localStorage.removeItem(CUSTOMER_SESSION_KEY);
    }
  } catch { /* ignore */ }
}

export function handleEdgeResult(res: any) {
  const err = res?.data?.error || res?.error?.message;
  if (typeof err === 'string' && err === 'session_invalidated') {
    try {
      window.dispatchEvent(new CustomEvent(SESSION_INVALIDATED_EVENT));
    } catch { /* ignore */ }
  }
  return res;
}
